import { toast } from '@/shared/components/toasts/PlatformToast';

import { getApiErrorMessage } from './errors';

type ToastApiErrorOptions = {
    description?: string;
    fallbackMessage?: string;
};

export function toastApiError(error: unknown, options: ToastApiErrorOptions = {}) {
    toast.error(getApiErrorMessage(error, options.fallbackMessage), {
        description: options.description,
    });
}
